/* ============================================================ FAQ search
   The search behind the FAQ page and the support page's suggestions. No AI
   and nothing leaves the page: it ranks the questions already there.

   - Questions are read as a rider would ask them: filler words ("how do I",
     "can my", "is it") are dropped, so a whole question searches as well as
     a keyword.
   - Words are reduced to a stem ("batteries", "battery" → "batteri";
     "charging", "charged" → "charg"), so plurals and tenses match.
   - A rider's words are matched to KEIS's: "gilet" finds bodywarmers, "how
     long will it last" finds run times, "send it back" finds returns.
   - A typo still finds its word, if only one or two letters are off.
   - Answers are ranked, not just filtered: a word in the question counts for
     more than one in the answer, a rare word for more than a common one, and
     a question that contains the search as a phrase goes to the top.

   window.KeisFaqSearch.index(docs)  docs: [{ q, a, ctx }], plain text
   window.KeisFaqSearch.search(index, query) → [{ i, score }] best first
   ========================================================================= */
(function () {
  'use strict';
  if (window.KeisFaqSearch) return;

  var STOP = ('a an the and or but if of to in on at by for from with without into onto about as is are was were be ' +
    'been being am do does did doing done have has had having i me my mine we our us you your yours it its this that ' +
    'these those there here what which who whom whose when where why how can could should would will shall may might ' +
    'must just so than too very any some all each every no not yes please thanks thank hi hello get got keis ' +
    'there s t im ive id dont doesnt cant wont isnt arent long take').split(' ');
  var STOPSET = {};
  STOP.forEach(function (w) { STOPSET[w] = true; });

  /* Riders' words on the left, the words KEIS answers use on the right. Each
     group is matched both ways, at a little less weight than the word typed. */
  var SYNONYMS = [
    'bodywarmer bodywarmers gilet gilets vest vests waistcoat',
    'jacket jackets coat coats',
    'trouser trousers pants legs',
    'glove gloves mitt mitts mittens hands',
    'sock socks feet foot insole insoles',
    'runtime runtimes run last lasts hours duration life',
    'battery batteries powerbank pack packs',
    'charge charging charger charged recharge',
    'wash washing washed clean cleaning machine laundry',
    'size sizes sizing fit fitting small large big tight measure',
    'return returns refund refunds exchange exchanges swap',
    'delivery deliver shipping ship postage despatch dispatch courier arrive',
    'track tracking where order parcel',
    'fuse fuses amp amps ampere',
    'connect connection connecting wire wiring wired lead leads cable cables plug plugs sae optimate hub',
    'controller controllers remote bluetooth app settings',
    'waterproof rain wet water membrane hipora',
    'warranty guarantee faulty fault broken repair repairs stopped working',
    'bike motorcycle motorbike scooter 125cc vehicle',
    'discount discounts code codes voucher offer promo',
    'cancel cancelling cancellation',
    'invoice receipt vat',
    'touchscreen touch phone smartphone screen',
    'heat heated warm warmth hot temperature',
    'pillion passenger',
    'women womens woman ladies lady female',
    'overseas international abroad worldwide europe eu customs'
  ].map(function (g) { return g.split(' '); });

  /* Whole phrases riders use, read as the word the answers use. Checked on
     the search as typed; each adds its words to the search. */
  var PHRASES = [
    [/\bhow long\b.*\b(last|run|battery|batteries|charge)\b|\bbattery life\b|\b(last|run)s? (for|on)\b/, 'runtime'],
    [/\bhow long\b.*\b(deliver|delivery|arrive|take to come|shipping|post)\b/, 'delivery'],
    [/\bwhere('?s| is) my (order|parcel|delivery)\b|\bhasn'?t arrived\b|\bnot arrived\b/, 'track tracking'],
    [/\bsend (it|them|my \w+)? ?back\b|\bmoney back\b/, 'return refund'],
    [/\b(stopped|not|isn'?t|doesn'?t|won'?t) (working|work|heating|heat|warm)\b|\bbroken\b|\bfaulty\b/, 'repair warranty'],
    [/\b(nhs|blue light|police|paramedic|nurse|firefighter|emergency services)\b/, 'blue light discount'],
    [/\b125(cc)?\b|\bsmall bike\b|\bscooter\b/, '125cc'],
    [/\b(germany|france|spain|ireland|italy|netherlands|belgium|usa|america|canada|australia|norway|sweden|abroad|outside the uk)\b/, 'overseas shipping'],
    [/\b(against|next to) (my|the) skin\b|\bbase ?layer\b/, 'skin base layer'],
    [/\bhow (hot|warm)\b/, 'warm heat'],
    [/\b(too|very) (hot|cold)\b/, 'controller heat settings']
  ];

  var norm = function (s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/['’]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
  };

  /* A light stemmer: enough to join plurals and tenses, never so much that
     unrelated words meet. */
  var stem = function (w) {
    if (w.length <= 3 || /^\d/.test(w)) return w;
    return w
      .replace(/ies$/, 'i').replace(/y$/, 'i')
      .replace(/(ss)es$/, '$1').replace(/([^s])s$/, '$1')
      .replace(/ing$/, '').replace(/ed$/, '')
      .replace(/(.)\1$/, '$1');
  };

  var words = function (s) {
    return norm(s).split(' ').filter(function (w) { return w && !STOPSET[w]; });
  };

  var SYN = {};
  SYNONYMS.forEach(function (g) {
    var stems = g.map(stem);
    stems.forEach(function (s) { SYN[s] = (SYN[s] || []).concat(stems.filter(function (x) { return x !== s; })); });
  });

  /* Edit distance, capped: anything beyond `max` is "too far". */
  var near = function (a, b, max) {
    if (Math.abs(a.length - b.length) > max) return false;
    var prev = [], cur, i, j;
    for (j = 0; j <= b.length; j += 1) prev[j] = j;
    for (i = 1; i <= a.length; i += 1) {
      cur = [i];
      var best = i;
      for (j = 1; j <= b.length; j += 1) {
        cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
        if (cur[j] < best) best = cur[j];
      }
      if (best > max) return false;
      prev = cur;
    }
    return prev[b.length] <= max;
  };

  var FIELDS = { q: 3, ctx: 2, a: 1 };

  function index(docs) {
    var df = {};
    var list = docs.map(function (d) {
      var f = {};
      var seen = {};
      Object.keys(FIELDS).forEach(function (k) {
        f[k] = {};
        words(d[k]).map(stem).forEach(function (s) {
          f[k][s] = (f[k][s] || 0) + 1;
          seen[s] = true;
        });
      });
      Object.keys(seen).forEach(function (s) { df[s] = (df[s] || 0) + 1; });
      return { f: f, q: ' ' + norm(d.q) + ' ' };
    });
    return { docs: list, df: df, vocab: Object.keys(df), n: list.length };
  }

  function search(ix, query) {
    var raw = norm(query);
    var said = String(query || '').toLowerCase();
    var extra = '';
    PHRASES.forEach(function (p) { if (p[0].test(said)) extra += ' ' + p[1]; });
    /* A word a phrase stood for counts for more than the words around it:
       "where is my order" is about tracking, whatever else says "order". */
    var boosted = {};
    words(extra).map(stem).forEach(function (t) { boosted[t] = true; });
    var terms = words(query + extra).map(stem).filter(function (t, i, all) { return all.indexOf(t) === i; });
    if (!terms.length) return [];

    /* Each term, with its typo-corrections and synonyms, each at a weight. */
    var expanded = terms.map(function (t) {
      var alts = {};
      alts[t] = boosted[t] ? 1.6 : 1;
      if (!ix.df[t] && t.length >= 4) {
        var max = t.length >= 7 ? 2 : 1;
        ix.vocab.forEach(function (v) { if (v[0] === t[0] && near(t, v, max)) alts[v] = Math.max(alts[v] || 0, 0.8); });
      }
      Object.keys(alts).forEach(function (a) {
        (SYN[a] || []).forEach(function (s) { if (!alts[s]) alts[s] = 0.6; });
      });
      return alts;
    });

    var out = [];
    ix.docs.forEach(function (d, i) {
      var score = 0, hit = 0;
      expanded.forEach(function (alts) {
        var best = 0;
        Object.keys(alts).forEach(function (s) {
          if (!ix.df[s]) return;
          var idf = Math.log(1 + (ix.n - ix.df[s] + 0.5) / (ix.df[s] + 0.5));
          Object.keys(FIELDS).forEach(function (k) {
            var tf = d.f[k][s];
            if (tf) best = Math.max(best, FIELDS[k] * idf * alts[s] * (tf * 2.2) / (tf + 1.2));
          });
        });
        if (best > 0) hit += 1;
        score += best;
      });
      if (!hit) return;
      /* Every term found counts for more than a few found twice. */
      score *= 0.5 + 0.5 * (hit / terms.length);
      if (raw.length > 3 && d.q.indexOf(' ' + raw + ' ') !== -1) score *= 1.6;
      out.push({ i: i, score: score, hit: hit });
    });
    out.sort(function (a, b) { return b.score - a.score; });
    if (!out.length) return out;
    /* Keep what is plausibly relevant: well short of the best is noise. */
    var floor = out[0].score * 0.28;
    return out.filter(function (r) { return r.score >= floor; });
  }

  window.KeisFaqSearch = { index: index, search: search, norm: norm };
})();
